import React, { useEffect, useState } from 'react'
import useFetch from 'use-http'

import {
  Alert,
  BackgroundImage,
  Button,
  Box,
  Column,
  Columns,
  Form,
  Heading,
  Image,
  Stack,
  TextField,
} from '@myxplor/stardust'

import { setAuthToken } from '~/src/modules/auth'

import splashImage from '~/src/assets/splash.png'
import xplorRocketImage from '~/src/assets/xplor_rocket.png'

const Login = () => {
  const [error, setError] = useState<Nullable<string>>(null)
  const [identifier, setIdentifier] = useState('')
  const [password, setPassword] = useState('')

  const authRequest = useFetch('/api/v1/session', {
    headers: { 'Content-Type': 'application/json' },
  })

  const onLogin = async () => {
    setError(null)

    const response = await authRequest.post({
      identifier,
      password,
    })

    if (response.errors) {
      setError('Login failed, please check your username and password')
    } else {
      setAuthToken(response.data.token)
      window.location.pathname = '/accounts'
    }
  }

  return (
    <Box backgroundColor="highestBlend" height="100vh" width="100vw">
      <Columns>
        <Column alignY="center" width={[1, 1 / 2, 1 / 3, 1 / 5]}>
          <Box padding={['small', 'large']} width={1}>
            <Form onSubmit={onLogin}>
              <Stack space="large">
                <Box display="flex" justifyContent="center" position="absolute" top={-64} width={1}>
                  <Image height={64} src={xplorRocketImage} width={64} />
                </Box>
                <Heading level={4}>Login</Heading>
                <Stack space="small">
                  <TextField
                    label="Email"
                    value={identifier}
                    onChange={(value: string) => setIdentifier(value)}
                  />
                  <TextField
                    label="Password"
                    type="password"
                    value={password}
                    onChange={(value: string) => setPassword(value)}
                  />
                  {error && <Alert tone="negative">{error}</Alert>}
                </Stack>
                <Button disabled={authRequest.loading} fill size="large" type="submit">
                  Login
                </Button>
              </Stack>
            </Form>
          </Box>
        </Column>
        <Column width={[0, 3 / 5, 2 / 3]}>
          <BackgroundImage height="100vh" image={splashImage} width={1} />
        </Column>
      </Columns>
    </Box>
  )
}

export default React.memo(Login)
